import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import {
  getAllBookings,
  confirmBooking,
  createBooking,
  getAvailableDrivers,
  completeBooking,
  cancelBooking,
  updateBooking,
} from "./bookings.service";

export const useGetAllBookings = () => {
  return useQuery({
    queryKey: ["bookings"],
    queryFn: getAllBookings,
  });
};

export const useCreateBooking = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: createBooking,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["bookings"] });
    },
  });
};

export const useUpdateBooking = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ bookingId, bookingData }) =>
      updateBooking({ bookingId, bookingData }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["bookings"] });
    },
  });
};

export const useConfirmBooking = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: confirmBooking,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["bookings"] });
    },
  });
};

export const useGetAvailableDrivers = (params) => {
  return useQuery({
    queryKey: ["availableDrivers", params],
    queryFn: () => getAvailableDrivers(params),
    enabled: Boolean(params?.pickupDateTime && params?.dropoffDateTime),
  });
};

export const useCompleteBooking = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ bookingId, payload }) =>
      completeBooking({ bookingId, payload }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["bookings"] });
    },
  });
};

export const useCancelBooking = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ bookingId, payload }) =>
      cancelBooking({ bookingId, payload }),
    onSuccess: () => {
      [["bookings"], ["payments"]].forEach((key) =>
        queryClient.invalidateQueries({ queryKey: key }),
      );
    },
  });
};
